import { create } from "zustand";
import { immer as immerMiddleware } from "zustand/middleware/immer";
import { Div } from "../components/general/div";

interface State {
  Rating: any;

  initiateRating: (rating: any) => void;
}

export const useRatingComponent = create<State>()(
  immerMiddleware((set, get) => ({
    Rating: Div,
    initiateRating: (rating) => {
      set((state) => {
        state.Rating = rating;
      });
    },
  })),
);
